import React from "react";
import { Rating as BaseRating } from "react-simple-star-rating";

export function Rating(props) {
  let rating = props.rating;

  return (
    <div>
      {/* set initial value */}
      <BaseRating initialValue={rating} readonly={true} size={25} />
    </div>
  );
}
